import { getCurrentInstance as g, ref as h, computed as $, watch as k, useModel as C, onMounted as I, onBeforeUnmount as b, unref as x } from "vue";
function M({
  autoValidate: u,
  validated: c,
  inputElement: V,
  customCheckValidity: d
}) {
  var v;
  const o = (v = g()) == null ? void 0 : v.proxy, r = h("default"), f = $(() => (c == null ? void 0 : c.value) ?? r.value);
  k(f, () => o == null ? void 0 : o.$emit("update:validated", f.value));
  const [s, a] = C((o == null ? void 0 : o.$props) ?? {}, "modelValue");
  function l() {
    return x(V) ?? (o == null ? void 0 : o.$el);
  }
  function m(t) {
    const e = l();
    e && e.constructor.prototype.setCustomValidity.call(e, t), t || (r.value = "default");
  }
  function p() {
    if (d)
      return d();
    const t = l();
    return t && t.constructor.prototype.checkValidity.call(t) ? (r.value = "success", !0) : !1;
  }
  function i(t = !1) {
    const e = r.value, n = p();
    if (!t || n && e !== "success" || !n && e !== "error") {
      const y = l();
      y && y.constructor.prototype.reportValidity.call(y);
    }
    return n;
  }
  return I(() => {
    const t = l();
    t && (t.setCustomValidity = m, t.checkValidity = p, t.reportValidity = i);
  }), b(() => {
    const t = l();
    if (t) {
      const e = t.constructor.prototype;
      t.setCustomValidity = e.setCustomValidity, t.checkValidity = e.checkValidity, t.reportValidity = e.reportValidity;
    }
  }), {
    value: s,
    innerValidated: r,
    effectiveValidated: f,
    checkValidity: p,
    reportValidity: i,
    setCustomValidity: m,
    onInput(t) {
      o == null || o.$emit("input", t), a.lazy || (s.value = t.target.value), u === "input" ? i() : r.value = "default";
    },
    onBlur(t) {
      o == null || o.$emit("blur", t), u === "blur" ? i(!0) : typeof u == "string" && ["input", "change"].includes(u) && r.value === "default" && p();
    },
    onChange(t) {
      o == null || o.$emit("change", t), a.lazy && (s.value = t.target.value), u === "change" && i();
    },
    onInvalid(t) {
      o == null || o.$emit("invalid", t), r.value = "error";
    },
    onKeyUp(t) {
      o == null || o.$emit("keyup", t), t.key === "Enter" && (u === !0 || u === "") && i();
    }
  };
}
export {
  M as useInputValidation
};
